import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {HelperService} from '@app/services/helper.service';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-deleted-screen',
    imports: [CommonModule],
    templateUrl: './deleted-screen.component.html',
    styleUrls: ['./deleted-screen.component.scss']
})
export class DeletedScreenComponent {
	public appName: string;

	constructor(
		private router: Router,
		private helperService: HelperService
	) {
		this.appName = this.helperService.appName();
	}

	goToStories() {
		this.router.navigate(['stories']);
	}

}
